import { memo } from "react";

import { QuestionPlanMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target";

import { usePlanMainTarget } from "./hooks";

export const QuestionMainTarget = memo(() => {
	const { mainTarget, onSetMainTarget } = usePlanMainTarget();

	return <QuestionPlanMainTarget mainTarget={mainTarget} onSetMainTarget={onSetMainTarget} />;
});

QuestionMainTarget.displayName = "QuestionMainTarget";
